import { Container } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';
import image from '../../Assets/img/NotFound.png'

function NoMatch(){
    return (
        <Container>
            <h1>404 NOT FOUND</h1>
            <Image fluid={true} src={image} alt="Resource Not Found" />
        </Container>
    );
};

export default NoMatch;